module.exports = __webpack_public_path__ + "static/media/Group 1535.a22b007a.svg";